__webpack_require__.p = "/lampabikt/";